export default __webpack_public_path__ + "static/media/gallery_00.59826047.jpg";